import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { completeLogin } from "../lib/auth";

/**
 * OAuth redirect target. Exchanges the code + PKCE verifier for tokens
 * and routes the user into /accounts on success.
 */
export default function Callback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    completeLogin(params)
      .then(() => navigate("/accounts", { replace: true }))
      .catch((e: Error) => setError(e.message));
  }, [params, navigate]);

  if (error) {
    return (
      <section className="callback">
        <h1>Sign-in failed</h1>
        <pre>{error}</pre>
        <button onClick={() => navigate("/", { replace: true })}>Back</button>
      </section>
    );
  }

  return (
    <section className="callback">
      <p>Signing you in&hellip;</p>
    </section>
  );
}
